import React from 'react';
import './Telegram.css';

const Telegram = () => {
  // Use an emoji image with png extension
  const telegramImg = "/images/emoji9.png";

  return (
    <div className="telegram-page">
      <div className="container">
        <h1 className="section-title">Join our X Community</h1>
        
        <div className="telegram-content">
          <div className="telegram-image">
            <img src={telegramImg} alt="Telegram Group" />
          </div>
          
          <div className="telegram-info">
            <p className="telegram-description">
              Join our X Community to stay updated on the latest news, 
              participate in events, and connect with our community!
            </p>
            
            <a href="https://x.com/i/communities/1912529619669889411" target="_blank" rel="noopener noreferrer" className="telegram-btn">
              Join our X Community!
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Telegram; 